import React, { Component } from "react";
import { createCourseCategory } from "../../../services/course";
import AppContext from "../../../contexts/AppContext";

class CategoryModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                title: "",               
            },
            errors: {},
            success: {},           
        };
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        
        if(!fields.title){
            formIsValid = false;
            errors.title = "Please enter title";
        }         

        this.setState({errors: errors});
        return formIsValid;
    }

    componentDidMount() {
        this.setState({ item: this.state.item });
    }

    create = e => {
        e.preventDefault();
        if(this.handleValidation()){
            const formData = new FormData()
            let errors = {};
            formData.append(
                'title',
                this.state.item.title,
            )
            
            createCourseCategory(formData)
            .then(response => {
                this.props.hideCreate();
                this.props.listCats(response.data);
                
            })
            .catch(errors => {
                console.log(errors);
            });
        }
        
    };

    handleChange(field){    		
        

        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Add New Category</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="name">Title</label>
                                <input
                                            id="title"
                                            name="title"  
                                            onChange={this.handleChange.bind(this)}                                            
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="text-danger">
                                                {this.state.errors.title || ''}
                                            </div>
                                        ) : null}
                            </div>
                           
                            
                            <button
                                type="button"
                                onClick={this.create}
                                className="btn btn-primary mr-2"
                            >
                                Add Category
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CategoryModel.contextType = AppContext;
export default CategoryModel;



// WEBPACK FOOTER //
// ./src/components/admin/courses/categoryModal.js